module.exports = __webpack_public_path__ + "img/line_10.92294ce5.jpg";